import React, { useState, useEffect } from "react";
import {
  ArticleComposer,
  ContentfulResponse,
} from "@soluto-private/content-component-library";

import FakeBrowser from "./FakeBrowser";
import VendorSwitching from "./VendorSwitching";

interface Props {
  vendor: "sprint" | "verizon" | "asurion" | "att" | "staples" | "cricket";
  preview?: boolean;
  response: ContentfulResponse;
}

const Article: React.FC<Props> = (props: Props): React.ReactElement => {
  const [vendor, setVendor] = useState(props.vendor);
  const [loading, setLoading] = useState(false);

  useEffect((): void => {
    setLoading(true);
    setTimeout((): void => {
      setLoading(false);
    }, 1);
  }, [vendor]);

  if (loading) {
    return <div />;
  }

  if (props.preview && !loading) {
    return (
      <>
        <VendorSwitching
          vendor={vendor}
          setVendor={setVendor}
          articleId={(props.response.sys && props.response.sys.id) || null}
        />
        <FakeBrowser>
          <ArticleComposer
            vendor={vendor}
            response={props.response}
            source="contentful_renderer"
          />
        </FakeBrowser>
      </>
    );
  }

  return (
    <ArticleComposer
      vendor={vendor}
      response={props.response}
      source="contentful_renderer"
    />
  );
};

export default Article;
